"use strict";
/**
 * Represents either an inputted or suggested item
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneTimeframe = void 0;
var common_1 = require("../common");
var MilestoneTimeframe = /** @class */ (function (_super) {
    __extends(MilestoneTimeframe, _super);
    function MilestoneTimeframe(props, min, max) {
        if (props === void 0) { props = {}; }
        return _super.call(this, __assign(__assign({}, MilestoneTimeframe.defaultProps(min, max)), props)) || this;
    }
    MilestoneTimeframe.months = function () {
        return ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
    };
    MilestoneTimeframe.monthFromDate = function (date) {
        return MilestoneTimeframe.monthFromIndex(date.getMonth());
    };
    MilestoneTimeframe.monthFromIndex = function (index) {
        return MilestoneTimeframe.months()[index];
    };
    MilestoneTimeframe.defaultProps = function (min, max) {
        return {
            month: {
                min: MilestoneTimeframe.monthFromDate(min),
                max: MilestoneTimeframe.monthFromDate(max)
            },
            year: {
                min: min.getFullYear(),
                max: max.getFullYear()
            },
            date: {
                min: min.toISOString(),
                max: max.toISOString()
            }
        };
    };
    return MilestoneTimeframe;
}(common_1.AbstractModelLight));
exports.MilestoneTimeframe = MilestoneTimeframe;
